import { useSubscriptionAppData } from '@modules/subscription/hooks/use-subscription-app-data'
import { SubscriptionTypeStrategy } from '@store/slices/subscription-slice'
import { SubscriptionType } from '@modules/subscription/models'

export const useSubscriptionTypeStrategyProvider = (subscriptionType: SubscriptionType): SubscriptionTypeStrategy => {
  const appData = useSubscriptionAppData()

  return appData.subscription_types[subscriptionType]
}
